
export class ChangeSet {

    constructor() {
        this._changes = [];  // Maintains an ordered list of ALL changes. Need this for applying in the correct order.
        this._stagedChanges = [];
        this._committedChanges = []
    }

    getChanges() {
        return this._changes;
    }

    toJSON() {
        return {
            _changes: this._changes.map(c => c.toJSON()),
            _stagedChanges: this._changes.map(c => c.toJSON()),
            _committedChanges: []
        };
    }

    static fromJSON(json, changeClasses) {
        const changeSet = new ChangeSet();
        if (json._changes) {
            changeSet._changes = json._changes.map(c => {
                const ChangeClass = changeClasses[c.className];
                if (!ChangeClass) {
                    console.error("Available change classes:", Object.keys(changeClasses), "Requested:", c.className, "by", c);
                    throw new Error(`ChangeSet.fromJSON: Unknown change type: ${c.className}`);
                }
                return ChangeClass.fromJSON(c);
            });
        }
        if (json._stagedChanges) {
            changeSet._stagedChanges = json._stagedChanges.map(c => {
                const ChangeClass = changeClasses[c.className];
                if (!ChangeClass) {
                    console.error("Available change classes:", Object.keys(changeClasses), "Requested:", c.className, "by", c);
                    throw new Error(`ChangeSet.fromJSON: Unknown change type: ${c.className}`);
                }
                return ChangeClass.fromJSON(c);
            });
        }
        if (json._committedChanges) {
            changeSet._committedChanges = json._committedChanges.map(c => {
                const ChangeClass = changeClasses[c.className];
                if (!ChangeClass) {
                    console.error("Available change classes:", Object.keys(changeClasses), "Requested:", c.className, "by", c);
                    throw new Error(`ChangeSet.fromJSON: Unknown change type: ${c.className}`);
                }
                return ChangeClass.fromJSON(c);
            });
        }
        for (const change of changeSet._changes) {
            change.setChangeSet(changeSet);
        }
        return changeSet;
    }

    rollback() {
        this._stagedChanges = this._committedChanges;
        this._committedChanges = [];
        for (const change of this._stagedChanges) {
            change.rollback();
            change.setChangeSet(this);
        }
    }

    isCommitted() {
        return this._committedChanges.length > 0 && this._stagedChanges.length === 0;
    }

    commitAll() {
        if (this._stagedChanges.length === 0) {
            // console.warn("ChangeSet.commitAll: No staged changes to commit.");
            return this;
        }
        for (const change of this._stagedChanges) {
            this.commit(change);
        }
        return this;
    }

    commit(change) {
        if (!change) {
            console.error("ChangeSet.commit: change is required. Got: ", change);
            throw new Error("ChangeSet.commit: change is required");
        }
        this.remove(change);
        change.setChangeSet(this);
        this._committedChanges.push(change);
        this._changes.push(change);
        return this;
    }

    stage(change) {
        this.remove(change);
        change.setChangeSet(this);
        this._stagedChanges.push(change);
        this._changes.push(change);
        return this;
    }

    remove(change) {
        if (!change) {
            console.error("ChangeSet.remove: change is required. Got: ", change);
            throw new Error("ChangeSet.remove: change is required");
        }
        change.setChangeSet(null);

        const stagedChanges = [];
        for (const c of this._stagedChanges) {
            if (c !== change) {
                stagedChanges.push(c);
            }
        }
        this._stagedChanges = stagedChanges;

        const committedChanges = [];
        for (const c of this._committedChanges) {
            if (c !== change) {
                committedChanges.push(c);
            }
        }
        this._committedChanges = committedChanges;

        const changes = [];  // TODO: I don't think we ever want to do this.
        for (const c of this._changes) {
            if (c !== change) {
                changes.push(c);
            }
        }
        this._changes = changes;
        return this;
    }

    has(change) {
        return this._changes.includes(change);
    }

    getCommittedChanges() {
        return this._committedChanges;
    }

    getStagedChanges() {
        return this._stagedChanges;
    }

}